import { Brick, registerBrick } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class StringToUTCDateTime extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} dateTimeString
     * @param {function(*)} setDate
     */
    update($, [dateTimeString], [setDate]) {
        try {
            let [year, month, day] = dateTimeString.split('-');
            year = year.substring(0, 4); // To save only four characters
            const date = new Date(Date.UTC(Number.parseInt(year), Number.parseInt(month) - 1, Number.parseInt(day)));
            if (!isNaN(date) && Number.parseInt(year) > 1900) {
                setDate(date);
            }
        } catch (e) {
            getLogger('Parse Date Time').error(e);
        }
    }
}

registerBrick('018c15f7a972a9b89fa4', StringToUTCDateTime);
